var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNeutralisation = function SvgNeutralisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Neutralisation_svg__Ebene_2",
    viewBox: "0 0 87.52 87.52"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Neutralisation_svg__cls-1{fill:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Neutralisation_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.39 31.34H19.14a1.23 1.23 0 1 0 0 2.46h49.25a1.23 1.23 0 1 0 0-2.46M50.48 58.21H37.05a1.23 1.23 0 1 0 0 2.46h13.43a1.23 1.23 0 1 0 0-2.46M59.43 44.77H28.09a1.23 1.23 0 1 0 0 2.46h31.34a1.23 1.23 0 1 0 0-2.46",
    className: "Neutralisation_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76 0C19.63 0 0 19.63 0 43.76s19.63 43.76 43.76 43.76 43.76-19.63 43.76-43.76S67.89 0 43.76 0m0 85.07c-22.78 0-41.31-18.53-41.31-41.31S20.98 2.45 43.76 2.45s41.31 18.53 41.31 41.31-18.53 41.31-41.31 41.31",
    className: "Neutralisation_svg__cls-1"
  }))));
};
export default SvgNeutralisation;